import "../components/general/ErrorOverlay";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";

const container = document.getElementById("wizard");
if (!container) {
	throw new Error("Could not find the wizard container");
}

const root = createRoot(container);
root.render(
	<StrictMode>
		<App />
	</StrictMode>,
);
